import { useState } from 'react';
import { useAuth } from '@clerk/react';
import { Button } from '@mantine/core';
import { IconCoin } from '@tabler/icons-react';
import { useApi, useSession } from '../../api';
import TipModal from './TipModal';

// "Send a tip" entry point (contract §4.15), rendered on the princess profile
// hero next to FavoriteButton. Hidden when:
// - signed out (tips require CurrentUser),
// - CCBill isn't configured (payments_enabled on GET /subscription/plans §4.4),
// - the profile belongs to the viewer (backend rejects own-profile tips 400).
// The plans catalog is a cheap public GET and TanStack Query caches it.
const TipButton = ({ sellerId, sellerUserId, displayName, size = 'xs' }) => {
  const { isSignedIn } = useAuth();
  const { authextra } = useSession();
  const [opened, setOpened] = useState(false);

  const { data: plansData } = useApi('/api/v1/subscription/plans', undefined, {
    enabled: !!isSignedIn,
  });

  if (!isSignedIn) return null;
  if (!plansData?.payments_enabled) return null;
  if (
    authextra?.user_id != null &&
    sellerUserId != null &&
    authextra.user_id === sellerUserId
  ) {
    return null;
  }

  return (
    <>
      <Button
        variant="light"
        color="yellow"
        size={size}
        leftSection={<IconCoin size="1rem" />}
        onClick={() => setOpened(true)}
      >
        Send a tip
      </Button>
      <TipModal
        opened={opened}
        onClose={() => setOpened(false)}
        sellerId={sellerId}
        displayName={displayName}
      />
    </>
  );
};

export default TipButton;
